<app-list-animations-reunions *ngIf="loadingData; else loader" [allList]="listAllAnimations" [permToAdd]="permToAdd"
  [listEnfant]="listChild" [contrats]="listContrats" [configMentalo]="configMentalo" type="animation"
  (unsubscribeEvent)="unsubscribe($event)" (unsubscribeChildEvent)="unsubscribeChild($event)"
  (registerChildEvent)="registerChild($event)">
</app-list-animations-reunions>

<ng-template #loader>
  <app-loader [message]="'Chargement des données...'" class="margin"></app-loader>
</ng-template>